"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formatGetUrl_1 = require("./formatGetUrl");
/**
 * Helper function for interacting with `fetch`.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#ajaxconfig}
 */
function ajax(config) {
    var method = config.method ? config.method.toUpperCase() : 'GET';
    var url;
    var customConfig = {};
    var headers = __assign({}, config.headers);
    if (method === 'GET') {
        url = formatGetUrl_1.default(config.url, config.data);
    }
    else {
        url = config.url;
        customConfig.body = JSON.stringify(config.data);
    }
    // Remove config properties that are formatted by this function
    var _u = config.url, _d = config.data, _m = config.method, _h = config.headers, filtered_config = __rest(config, ["url", "data", "method", "headers"]);
    return fetch(url, __assign(__assign({ method: method, credentials: 'same-origin', headers: new Headers(__assign({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, headers)) }, customConfig), filtered_config));
}
exports.default = ajax;
